"use client";
import clsx from "clsx";
import React from "react";

type Artist = {
  name: string;
  bio: string;
  keywords: string[];
  link: string;
};

const artistList: Artist[] = [
  {
    name: "Fiona Campbell",
    bio: "HereWeAre offers a vital sanctuary for our performing arts community - reconnecting artists and audiences in an instant, direct, and healthy way. HereWeAre is a declaration: artists at the forefront, audiences leaning in, together in a space that’s positive, uplifting, and truly ours.",
    keywords: ["Creative Director", "Musician", "Producer"],
    link: "https://hereweare.io/profile/PSO",
  },
  {
    name: "Suzy Wrong",
    bio: "The performing arts community needs something designed specifically to our needs, and that encourages us to interact in ways that are only constructive. A new platform that does not require us to capitulate to their exploitative capitalism.",
    keywords: ["Critic", "Broadcaster", "Actor", "Model"],
    link: "https://hereweare.io/profile/suzywrong",
  },
];

export default function ArtistMessageSection() {
  const onCliekLink = (link: string) => {
    window.open(`${link}`, "_blank");
  };

  return (
    <section
      className={clsx(
        "bg-white space-y-[2rem] py-[5rem] px-[1.5rem]",
        "sm:space-y-[3.5rem] sm:py-[7.5rem] sm:px-[4rem]",
        "lg:space-y-[5rem] lg:py-[10rem] lg:px-[5rem]"
      )}
    >
      <h5
        className={clsx(
          "text-[2rem] leading-[3rem]",
          "sm:text-[3.5rem] sm:leading-[4.5rem]",
          "lg:text-[5rem] lg:leading-[6rem]"
        )}
        style={{
          fontFamily: '"DM Serif Text", system-ui, sans-serif',
        }}
      >
        Artist Statements<span className="text-[#6B7EFF]">*</span>
      </h5>
      <div className="space-y-[2.5rem] sm:space-y-[5rem] lg:space-y-[7.5rem]">
        {artistList.map((artist, i) => {
          return (
            <div
              key={i}
              className="view-cursor space-y-[0.75rem] sm:space-y-[1rem] lg:space-y-[1.5rem]"
              onClick={() => {
                onCliekLink(artist.link);
              }}
            >
              <p
                className={clsx(
                  "text-[1.25rem] leading-[1.875rem]",
                  "sm:text-[1.5rem] sm:leading-[2.125rem]",
                  "lg:text-[2rem] lg:leading-[2.625rem]"
                )}
                style={{
                  fontFamily: '"DM Serif Text", system-ui, sans-serif',
                }}
              >
                {artist.name}
              </p>
              <p
                className={clsx(
                  "text-[#767676] text-[0.875rem] leading-[1.375rem] font-arial",
                  "sm:text-[1rem] sm:leading-[1.625rem]",
                  "lg:text-[1.25rem] lg:leading-[1.875rem]"
                )}
              >
                {artist.bio}
              </p>
              <div
                className={clsx(
                  "flex flex-wrap gap-[0.37rem] mt-[0.75rem] ",
                  "sm:gap-[0.5rem] mt-[0.5rem]",
                  "lg:gap-[0.75rem] mt-[1rem]"
                )}
              >
                {artist.keywords.map((keyword, j) => {
                  return (
                    <div
                      key={j}
                      className={clsx(
                        "bg-[#F5F5F5] px-[0.75rem] py-[0.5rem] color-[#222] text-[0.75rem] leading-[1.125rem] rounded-[0.5rem] font-arial",
                        "sm:px-[1rem] sm:text-[0.875rem] sm:leading-[1.5rem] sm:rounded-[0.75rem]",
                        "lg:px-[1.25] lg:py-[0.75rem] lg:text-[1rem] lg:leading-[1.625rem] lg:rounded-[1rem]"
                      )}
                    >
                      {keyword}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
